<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
  <path
    d="M1.7 14l4.3-4.6L8 11.3l5-4.6V5.3L8 9.9 1.6 4H13V3H0v12h9.8c-0.2-0.3-0.4-0.6-0.5-1H1.7zM1 13.3V4.8l4.3 4L1 13.3z"
    fill="currentColor" />
  <path
    d="M15.8 2c-0.1-0.1-0.2-0.2-0.4-0.2C15.2 1.8 15 2 15 2.3V10h-1.5c-1.6 0-2.8 1.5-2.4 3.2C11.3 14.2 12.3 15 13.5 15c1.4 0 2.5-1.1 2.5-2.5V5h2L15.8 2z"
    fill="currentColor" />
</svg>
